import { render, staticRenderFns } from "./ArticleView.vue?vue&type=template&id=e409bf04&scoped=true"
import script from "./ArticleView.vue?vue&type=script&lang=js"
export * from "./ArticleView.vue?vue&type=script&lang=js"
import style0 from "./ArticleView.vue?vue&type=style&index=0&id=e409bf04&prod&lang=scss"
import style1 from "./ArticleView.vue?vue&type=style&index=1&id=e409bf04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e409bf04",
  null
  
)

export default component.exports